<template>
  <div class="bind">
    <mt-header title="绑定手机号">
      <mt-button slot="left" icon="back" @click.native="hrefLogin">返回</mt-button>
    </mt-header>
    <div class="content">
      <p>{{this.nickname}},你好</p>
      <form>
        <div class="input_group">
          <icon name='mobile'></icon>
          <input type="tel" name="phone" v-model="phone" placeholder="请输入手机号" @input="phoneChange">
        </div>
        <div class="input_group">
          <icon name="envelope-open-o"></icon>
          <input type="text" id="codeVal" name="code" v-model="code" placeholder="请填写手机验证码">
          <button class="sendCode" type="button" ref="getCode" :disabled='canGet' @click="countDown()">获取验证码</button>
        </div>
        <div class="input_group">
          <icon name="lock"></icon>
          <input type="password" ref="pw" name="password" v-model="password" placeholder="请填写密码">
          <icon name="eye" class="look" :class="{'lookType':!lookType}" @click.native="seePw()"></icon>
        </div>
        <div class="btns">
          <button type="button" @click="bindWeChatNew">注册新账号</button>
          <button type="button" @click="bindWeChatOld">绑定已有账号</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Geetest from '../assets/js/gt'
import { Toast } from 'mint-ui'
var captcha = null
export default {
  name: 'bind',
  data () {
    return {
      canGet: true,
      phone: '',
      code: '',
      password: '',
      time: '60',
      lookType: 'false',
      // openid
      openid: '',
      // 微信昵称
      nickname: '',
      tmpGeetest: Geetest
    }
  },
  mounted () {
    this.openid = this.GetQueryString('openid')
    this.nickname = decodeURIComponent(this.GetQueryString('nickname'))
    this.initGeetested()
  },
  methods: {
    hrefLogin () {
      this.$router.push({path: '/passport/login'})
    },
    initGeetested () {
      var _this = this
      this.axios.get('/url/common/fastRegister?t=' + (new Date()).getTime())
      .then(function (data) {
        window.initGeetest({
          // 以下 4 个配置参数为必须，不能缺少
          gt: data.data.gt,
          challenge: data.data.challenge,
          offline: !data.data.success, // 表示用户后台检测极验服务器是否宕机
          new_captcha: data.data.new_captcha, // 用于宕机时表示是新验证码的宕机
          product: 'bind', // 产品形式，包括：float，popup
          width: '300px'
          // 更多配置参数说明请参见：http://docs.geetest.com/install/client/web-front/
        }, function (captchaObj) {
          captcha = captchaObj
          captchaObj.onReady(function () {
            console.log('onReady==========')
          }).onSuccess(function () {
            var result = captchaObj.getValidate()
            if (result) {
              _this.getCodeFromBack(result)
            } else {
              alert('验证失败')
            }
          })
        })
      })
    },
    getCodeFromBack: function (result) {
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/common/getWechatVerificationCode/1',
        params: {
          moblie: this.phone,
          challenge: result.geetest_challenge,
          validate: result.geetest_validate,
          seccode: result.geetest_seccode
        }
      }).then(function (response) {
        let msg = ''
        if (response.data.success) {
          msg = '发送成功'
          _this.runCode()
        } else {
          msg = response.data.msg
        }
        Toast({
          message: msg,
          position: 'middle',
          duration: 1000
        })
      }).catch(function (response) {
        Toast({
          message: '发送失败',
          position: 'middle',
          duration: 1000
        })
      })
    },
    // 绑定已有的手机号
    bindWeChatOld: function () {
      let _this = this
      if (this.openid === '' || this.nickname === '') {
        Toast({
          message: '微信登录失效',
          position: 'middle',
          duration: 1000
        })
        return false
      }
      var nickname = this.nickname
      var phone = this.phone
      var password = this.password
      var message = this.code
      var openid = this.openid
      this.axios({
        method: 'post',
        url: '/url/register/phoneBindOld',
        params: {
          password: password,
          phone: phone,
          username: nickname,
          message: message,
          wechatId: openid
        }
      }).then(function (response) {
        if (response.data.success) {
          _this.loginBindUser(_this.phone, _this.password)
        } else {
          Toast({
            message: response.data.msg,
            position: 'middle',
            duration: 1000
          })
        }
      }).catch(function (response) {
        Toast({
          message: response.data.msg,
          position: 'middle',
          duration: 1000
        })
      })
    },
    // 绑定新手机号
    bindWeChatNew: function () {
      let _this = this
      if (this.openid === '' || this.nickname === '') {
        Toast({
          message: '微信登录失效',
          position: 'middle',
          duration: 1000
        })
        return false
      }
      var nickname = this.nickname
      var phone = this.phone
      var password = this.password
      var message = this.code
      var openid = this.openid
      this.axios({
        method: 'post',
        url: '/url/register/bindWechat',
        params: {
          password: password,
          phone: phone,
          username: nickname,
          message: message,
          wechatId: openid
        }
      }).then(function (response) {
        if (response.data.success) {
          _this.loginBindUser(_this.phone, _this.password)
        } else {
          Toast({
            message: response.data.msg,
            position: 'middle',
            duration: 1000
          })
        }
      }).catch(function (response) {
        Toast({
          message: response.data.msg,
          position: 'middle',
          duration: 1000
        })
      })
    },
    // 登录
    loginBindUser: function (phone, password) {
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/api/ajaxSession',
        params: {
          name: _this.phone,
          password: _this.password,
          rememberMe: true
        }
      }).then(function (response) {
        if (response.data.success) {
          _this.STATE.state.loginState = response.data.success
          _this.STATE.state.loginPhone = _this.phone
          _this.STATE.state.loginId = response.data.data.loginID
          _this.$router.push({path: '/'})
        } else {
          _this.STATE.state.loginState = false
          Toast({
            message: response.data.msg,
            position: 'middle',
            duration: 1000
          })
        }
      }).catch(function (response) {
        _this.STATE.state.loginState = false
        Toast({
          message: response.data.msg,
          position: 'middle',
          duration: 1000
        })
        _this.$router.push({path: '/passport/login'})
      })
    },
    // 获取url中的参数
    GetQueryString: function (name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      var r = location.search.substr(1).match(reg)
      if (r !== null) {
        return unescape(r[2])
      } else {
        return null
      }
    },
    phoneChange: function () {
      var reg = /^((13|14|15|17|18)[0-9]{1}\d{8})$/
      var bol = reg.test(this.phone)
      if (bol) {
        this.canGet = false
      } else {
        this.canGet = true
      }
    },
    // 验证码倒计时
    runCode: function () {
      if (this.time === 0) {
        this.$refs.getCode.removeAttribute('disabled')
        this.$refs.getCode.innerHTML = '获取验证码'
        this.time = 60
      } else {
        this.$refs.getCode.setAttribute('disabled', true)
        this.$refs.getCode.innerHTML = this.time + '秒后获取'
        this.time --
        setTimeout(this.runCode, 1000)
      }
    },
    // 发送验证码
    countDown: function () {
      captcha.verify()
      // let _this = this
      // this.axios({
      //   method: 'post',
      //   url: '/url/common/getVerificationCode/1',
      //   params: {
      //     moblie: this.phone
      //   }
      // }).then(function (response) {
      //   let msg = ''
      //   if (response.data.success) {
      //     msg = '发送成功'
      //     _this.runCode()
      //   } else {
      //     msg = response.data.msg
      //   }
      //   Toast({
      //     message: msg,
      //     position: 'middle',
      //     duration: 1000
      //   })
      // }).catch(function (response) {
      //   Toast({
      //     message: '发送失败',
      //     position: 'middle',
      //     duration: 1000
      //   })
      // })
    },
    seePw: function () {
      if (this.$refs.pw.type === 'password') {
        this.$refs.pw.type = 'text'
        this.lookType = false
      } else {
        this.$refs.pw.type = 'password'
        this.lookType = true
      }
    }
  }
}
</script>

<style scoped>
.content{
  padding: 15px 5%;
}
.content form{
  margin: 10px 0;
}
.content p{
  font-size: 14px;
}
.input_group{
  line-height: 40px;
  margin: 5px 0;
  border-bottom: 1px solid #d9dedf;
}
.input_group .fa-icon{
  margin:0 5px;
  color: #7f8b98;
}
.input_group input{
  margin-left: 10px;
  outline: none;
  width: 75%;
  border: none;
  font-size: 14px;
  vertical-align: text-top;
}
.input_group input::-webkit-input-placeholder{
    color: #b7c3ca;
  }
  .input_group input:-moz-placeholder{
  　color:#b7c3ca;
  }
  .input_group input::-moz-placeholder{
  　color:#b7c3ca;
  }
  .input_group input:-ms-input-placeholder{
  　color:#b7c3ca;
  }
#codeVal{
  width: 50%;
  margin-left: 0;
}  
.sendCode{
  color: #fff;
  background-color: #108ee9;
  border: none;
  outline: none;
  height: 30px;
  -webkit-border-radiu:5px;
  -moz-border-radiu:5px;
  border-radius:5px;
  float: right;
  margin-top: 5px;
}
.look{
  float: right;
  margin-top: 10px!important;
  margin-right: 5px!important;
}
.btns{
  margin-top: 20%;
}
.btns button{
  display: block;
  width: 100%;
  height: 35px;
  -webkit-border-radiu:18px;
  -moz-border-radiu:18px;
  border-radius:18px;
  border: none;
  outline: none;
  padding: 0;
  color: #fff;
  margin-bottom: 15px;
}
.btns button:nth-child(1){
  background-color: #49586e;
}
.btns button:nth-child(2){
  background-color: #108ee9;
}
.lookType{
  color:#108ee9!important;
}
</style>



// WEBPACK FOOTER //
// accountBind.vue?7a24d292